import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ngx-modal',
  template: `
    <div class="modal-header">
      <span>{{ modalHeader }}</span>
      <button class="close" aria-label="Close" (click)="closeModal('close')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-footer">
    <button class="btn btn--primary fr" size="small" style="color:white;" (click)="Ok()">Yes</button>
    <button class="btn btn--primary fr" size="small" style="color:white;" (click)="closeModal()">No</button>
    </div>
  `,
})
export class ConfirmationModalComponent {

  modalHeader: string;
  modaldata:any;
  constructor(private activeModal: NgbActiveModal) {
  }

  ngOninit(){
  }

  Ok() {
    this.activeModal.close('');
  }

  closeModal(data) {
    this.activeModal.dismiss(data);
  }
}
